module.exports = __webpack_public_path__ + "img/culture2Hover.76d1a724.jpg";